import axios from 'axios';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const base = '/api/v1/nutrition/back-capture';

/**
 * #482: the Back Capture MENU is retired; the concept is not. The foliar
 * session page's inline Record action posts here, so the 90-day bound, the
 * captureMode='back_capture' marker and backCaptureBeyondLimit are all
 * unchanged. The route keeps its name deliberately — renaming a live endpoint
 * for cosmetics is churn with no user-visible gain.
 */
export interface NutritionBackCaptureFoliarPayload {
  date: string;
  tankCount: number;
}

export async function completeFoliar(
  comboId: string, payload: NutritionBackCaptureFoliarPayload,
): Promise<unknown> {
  const { data } = await axios.post(`${base}/foliar/${comboId}/complete`, payload, {
    headers: authHeaders(),
  });
  return data;
}
